<template>
    <div class="modal modal-slide-in new-user-modal fade" id="modals-slide-in">
        <div class="modal-dialog">
            <!-- route('client.store') post-->
          <form class="add-new-user modal-content pt-0">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" ref="closeAddClient">X</button>
            <div class="modal-header mb-1">
              <h5 class="modal-title" id="exampleModalLabel">New Client</h5>
            </div>
            <div class="modal-body flex-grow-1">
              <div class="form-group">
                <label class="form-label" for="basic-icon-default-fullname">First Name </label>
                <input
                  type="text"
                  class="form-control dt-full-name"
                  id="firstname"
                  placeholder=""
                  name="firstname"
                  aria-label=""
                  aria-describedby="basic-icon-default-fullname2"
                  v-model="firstname"
                />
                <div v-if="firstname != null">
                    <div v-if="vuelidate.firstname.$error" class="error mt-1">First Name {{vuelidate.firstname.$errors[0].$message.toLowerCase()}}</div>
                </div>

              </div>
              <div class="form-group">
                <label class="form-label" for="basic-icon-default-fullname"> Middle Name </label>
                <input
                  type="text"
                  class="form-control dt-full-name"
                  id="middle_name"
                  placeholder=""
                  name="middle_name"
                  aria-label=""
                  aria-describedby="basic-icon-default-fullname2"
                  v-model="middle_name"
                />
              </div>
              <div class="form-group">
                <label class="form-label" for="basic-icon-default-fullname"> Last Name </label>
                <input
                  type="text"
                  class="form-control dt-full-name"
                  id="lastname"
                  placeholder=""
                  name="lastname"
                  aria-label=""
                  aria-describedby="basic-icon-default-fullname2"
                  v-model="lastname"
                />
                <div v-if="lastname != null">
                    <div v-if="vuelidate.lastname.$error" class="error mt-1">Last Name {{vuelidate.lastname.$errors[0].$message.toLowerCase()}}</div>
                </div>
              </div>
              <div class="form-group">
                <label class="form-label" for="basic-icon-default-fullname">Email</label>
                <input
                  type="email"
                  class="form-control dt-full-name"
                  id="email"
                  placeholder=""
                  name="email"
                  aria-label=""
                  aria-describedby="basic-icon-default-fullname2"
                  v-model="email"
                />
                <div v-if="email != null">
                    <div v-if="vuelidate.email.$error" class="error mt-1">Email {{vuelidate.email.$errors[0].$message.toLowerCase()}}</div>
                </div>
              </div>
              <div class="form-group">
                <label class="form-label" for="basic-icon-default-fullname">Phone </label>
                <phone-input-component name="phone" :prop-phone="phone" @phoneInput="updatePhone"></phone-input-component>
              </div>
              <div class="form-group">
                <label class="form-label" for="basic-icon-default-fullname">Status </label>
                <select name="status" class="form-control"  @change="showChangeStatusAlert" v-model="status" >
                    <option value="">Please Select</option>
                    <option :value="status.title" v-for="(status,index) in businessStore.clientstatus">
                        {{status.title}}
                    </option>
                </select>
              </div>
              <div class="form-group">
                <label class="form-label" for="assigned_to">AssignedTo</label>
                <select name="status" class="form-control"  @change="showchangeAssignToAlert" v-model="AssignedTo" >
                    <option :value="teamUser.id" v-for="(teamUser,index) in teamUsers">
                        {{teamUser.user}}
                    </option>
                </select>
              </div>
              <button type="button" id="submit" name="submit" class="btn btn-primary mr-1 data-submit" @click="createClient">Submit</button>
              <button type="reset" class="btn btn-outline-secondary" data-dismiss="modal">Cancel</button>
            </div>
          </form>
        </div>
      </div>
</template>
<script>
import { ref, reactive } from 'vue'
import { useUserStore } from '../../../../stores/UserStore.js'
import { useBusinessStore } from '../../../../stores/BusinessStore.js'
import { useLocalizationStore } from '../../../../stores/LocalizationStore.js'
import { useVuelidate } from '@vuelidate/core'
import { required, email, maxLength, minLength, } from '@vuelidate/validators'

export default{
    components:{

    },
    props:{
        reloadtable:{
            type:Function
        }
    },
    setup(){
        const firstname = ref(),
        middle_name = ref(),
        lastname = ref(),
        phone = ref(null),
        email = ref(),
        status = ref('Lead'),
        AssignedTo = ref(null),
        closeAddClient = ref(),
        teamUsers = ref([]);
        return{
            firstname,middle_name,lastname,email,phone,status,AssignedTo,teamUsers,closeAddClient,
            userStore : useUserStore(),
            businessStore : useBusinessStore(),
            localizationStore : useLocalizationStore(),
            vuelidate: useVuelidate()
        }
    },
    watch:{
        async 'businessStore.business' (value) {
            let values = []
            this.AssignedTo = value.userId
            if(value.assignTo){
                const val = value.assignTo;
                for (const key in val) {
                    if (Object.hasOwnProperty.call(val, key)) {
                        const element = val[key];
                        values.push({id:key,user:element})
                    }
                }
            }
            this.teamUsers = values
        },
    },
    validations () {
        return {
            email : {
                required,
                email
            },
            firstname: { required},
            lastname: { required}

        }
    },
    methods:{
        createClient(){
            const $this=this;
            const route = this.$router.resolve(
                {
                    name:"admin-create-client"
                }
            );
            const params = {
                firstname:this.firstname,
                middle_name:this.middle_name,
                lastname:this.lastname,
                email:this.email,
                phone:this.phone,
                status:this.status,
                assigned_to:this.AssignedTo
            }
            this.vuelidate.$validate();
            if(this.vuelidate.$errors.length <= 0){
                axios.post(route.href,params).then(({data})=>{
                    if(data.error != true){
                        $this.$emit('clicked','/get/list/client?page=1')
                        $this.closeAddClient.click();
                        $this.clearFields()
                        toastr.success(data.message,'Add Client Success');
                        $this.tochangedata = {}
                        return;
                    }else{
                        toastr.error(data.message, 'Add Client Success Error!');
                        return;
                    }
                }).catch(function(error) {
                    toastr.error(error.response.data.response_msg, 'Add Client Success Error!');
                });
            }

        },
        clearFields(){
            this.firstname = null
            this.middle_name = ""
            this.lastname = null
            this.email = null
            this.phone = ""
            this.status = ""
            this.AssignedTo = ""
        },
        updatePhone(phone) {
            this.phone = phone;
        },
    }
}
</script>
